// 大区奖励列表和导出只传同一组财务筛选；路由携带筛选后刷新也可回显。
const filterKeys = [
  'ordernum', 'type', 'nameorpho', 'levelId', 'state', 'payType',
  'ywName', 'areaName', 'customerstate', 'isOneselfDeveloped',
  'timeType', 'startTime', 'endTime', 'payStartTime', 'payEndTime'
]

export function performanceFilters(source) {
  const result = {}
  filterKeys.forEach(key => {
    if (source && source[key] !== undefined && source[key] !== null && source[key] !== '') {
      result[key] = source[key]
    }
  })
  return result
}

export function parsePerformanceFilters(value) {
  try {
    return performanceFilters(JSON.parse(value || '{}'))
  } catch (e) {
    return {}
  }
}
